import Drawer from '@atoms/Drawer/Drawer';
import Icon from '@atoms/Icon/Icon';
import { PropsWithChildren, useState } from 'react';

interface Props {
  readonly onClick: () => void;
  readonly title: string;
  readonly subTitle?: string;
}

const ProductDetailsInformationButton = ({
  onClick,
  title,
  subTitle,
  children,
}: PropsWithChildren<Props>) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="body-two group flex w-full cursor-default border-transparent px-5 py-4 transition-all lg:cursor-pointer"
        onClick={() => {
          setIsDrawerOpen(true);
          onClick();
        }}
        data-testid="Product-Details-Information-Button"
      >
        <div className="flex w-full flex-row items-center justify-between transition-all lg:group-hover:text-grey-450 dark:lg:group-hover:text-yellow">
          <span
            className="flex flex-col gap-2 text-left"
            data-testid="Product-Details-Information-Button-Title"
          >
            {title}
            {subTitle && (
              <span
                className="body-four w-full text-grey-450 dark:text-grey-500"
                data-testid="Product-Details-Information-Button-Subtitle"
              >
                {subTitle}
              </span>
            )}
          </span>

          <Icon
            name="arrow_right"
            colorClassName="text-black-100 dark:text-yellow"
          />
        </div>
      </button>

      <Drawer setIsOpen={setIsDrawerOpen} isOpen={isDrawerOpen}>
        {children}
      </Drawer>
    </>
  );
};

export default ProductDetailsInformationButton;
